export const DeliveryType = {
  RESERVATION: 'RESERVATION',
  TAKEAWAY: 'TAKEAWAY',
  DELIVERY: 'DELIVERY',
};
